import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { ContentWrapper } from "../loading/LoadingSkeleton";
import { API_URL } from "../../config";

export default function Article() {
	const { id } = useParams();
	const [article, setArticle] = useState(false);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true);
	const [imageLoaded, setImageLoaded] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const cacheKey = `kriterion-article-${id}`;
				const cacheTimeKey = `kriterion-article-${id}-time`;
				const cachedData = localStorage.getItem(cacheKey);
				const cacheTime = localStorage.getItem(cacheTimeKey);
				
				if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < 300000) {
					const parsed = JSON.parse(cachedData);
					setArticle(parsed);
					setLoading(false);
					return;
				}

				const response = await axios.get(`${API_URL}/api/artikels/${id}`);
				
				const articleData = response.data.data;
				localStorage.setItem(cacheKey, JSON.stringify(articleData));
				localStorage.setItem(cacheTimeKey, Date.now().toString());
				
				setError("");
				setArticle(articleData);
				setLoading(false);
			} catch (e) {
				if (e.response?.status === 404) {
					setArticle(false);
					setError("Title not found");
				} else {
					setError("Something went wrong, try again later");
				}
				setLoading(false);
			}
		};

		fetchData();
		window.scrollTo(0, 0);
	}, [id]);

	// article && console.log(JSON.parse(article.attributes.Inhoud[1].Afbeelding));

	return (
		<ContentWrapper isLoading={loading && !error} loadingMessage="Artikel wordt geladen...">
			<Helmet>
				<title>{article ? `${article.attributes.MenuTitel} - Filmtheater Kriterion` : 'Artikel - Filmtheater Kriterion'}</title>
				<meta name="description" content={article ? `${article.attributes.MenuTitel} - Lees meer op Filmtheater Kriterion Amsterdam.` : 'Artikelen van Filmtheater Kriterion Amsterdam.'} />
			</Helmet>
			<div className="body-container">
			{article && (
				<div 
					className="article-content"
					style={{
						opacity: imageLoaded || !article.attributes.Inhoud.some(comp => comp.__component === "artikel.afbeelding") ? 1 : 0,
						transition: 'opacity 0.2s ease-in-out'
					}}
				>
					<h1 className="titel">{article.attributes.MenuTitel}</h1>
					{// eslint-disable-next-line
                    article.attributes.Inhoud.map((comp) => {
						// check if block is empty
						if (!comp) {
							return <p></p>
						}
						else if (comp.__component === "artikel.tekst") {
							return JSON.parse(comp.Tekst).blocks.map((block) => {
								return (
									<p
										className="tekst"
										key={block.id}
										dangerouslySetInnerHTML={{
											__html: block.data.text,
										}}
									/>
								);
							});
						} else if (comp.__component === "artikel.afbeelding") {
                            return (
                                <img
                                    className="artikel-image"
                                    key={comp.id || "1"}
                                    src={comp.Afbeelding.data.attributes.url}
                                    alt="Artikel afbeelding"
                                    loading="lazy"
                                    onLoad={() => setImageLoaded(true)}
                                />
                            )
                        } else if (comp.__component === "artikel.bestand") {
                            const fileUrl = comp.Bestand?.data?.attributes?.url;
                            const fileName = comp.Bestand?.data?.attributes?.name;
                            const linkUrl = comp.Link;
                            const href = fileUrl || linkUrl;
                            if (!href) return null;
                            return (
                                <a
                                    key={comp.id}
                                    className="artikel-bestand"
                                    href={href}
                                    target="_blank"
                                    rel="noreferrer"
                                    download={fileUrl ? fileName : undefined}
                                >
                                    <span className="artikel-bestand-icon">&#128196;</span>
                                    <span>{comp.Tekst || fileName || href}</span>
                                </a>
                            );
                        }
					})}
				</div>
			)}
			{error && <p className='error'>{error}</p>}
			</div>
		</ContentWrapper>
	);
}
